import { Component, forwardRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';
import { Moment } from 'moment';
import { INPUT_TYPES_CONFIG } from './../../../../config/products.config';
import { CLEAR_SELECT_INPUT_LABEL, DATE_INPUT_ID_LABEL } from '@ui-components/properties-form/properties-form.config';
import { ProfileService } from '@features/profile/profile.service';
import { OfferService } from '@features/profile/offer/offer.service';
import { DynamicInputService } from './dynamic-input.service';
import { PropertiesFormService } from '@ui-components/properties-form/properties-form.service';

@Component({
  standalone: false,
  selector: 'ingsv-adm-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicInputComponent),
      multi: true
    }
  ]
})
export class DynamicInputComponent implements OnChanges {
  @Input() inputData: any;
  @Input() inputId = '';
  @Input() productData;
  @Input() forceUseCarRegisterData = false;
  @Input() licencenceNumberEmptyFlow;
  @Input() isErrorParameter: boolean;

  @Output() sendDataOnEnter = new EventEmitter();
  @Output() updateFormOnSelectValue = new EventEmitter();

  @Output() ofvBrandIdSelected = new EventEmitter();
  @Output() ofvModelIdSelected = new EventEmitter();
  @Output() ofvModelregYearSelected = new EventEmitter();
  @Output() ofvModelYearSelected = new EventEmitter();
  @Output() useCarRegisterDataChanged = new EventEmitter();
  @Output() licenceNumberEmptyFlowChanged = new EventEmitter();

  public maxDate = new Date();
  ruleData: any;
  value: any;
  disabled = false;
  inputTypes = INPUT_TYPES_CONFIG;
  dateInputIdLabel = DATE_INPUT_ID_LABEL;
  multipleString = [];

  selectDataListLoader = false;
  selectDataList = [];
  selectedData = '';

  minRangeValue: any;
  maxRangeValue: any;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(
    public profileService: ProfileService,
    public offerService: OfferService,
    private dynamicInputService: DynamicInputService,
    private propertiesFormService: PropertiesFormService
  ) {}

  ngOnChanges(changes: any) {
    if (this.inputData) {
      if (this.inputData.propertyConfig && this.inputData.propertyConfig.settings) {
        const settingsMaxDate = this.inputData.propertyConfig.settings.maxDate;

        if (settingsMaxDate) {
          this.maxDate = new Date(settingsMaxDate);
        }
      }
    }
  }

  getSearchSelectOptions() {
    let options = [];

     if (
      this.inputData.propertyConfig &&
      this.inputData.propertyConfig.settings &&
      this.inputData.propertyConfig.settings.list) {
        options = this.inputData.propertyConfig.settings.list.map(listValue => {
          return listValue.value;
        });
     }

     return options;
  }

  isDefaultValue(): boolean {
    let defaultValuesData;

    if (this.inputData.propertyArrayName && this.productData
        && this.productData.properties && this.productData.properties[this.inputData.propertyArrayName]) {
      const additionalArrayObject = this.productData.properties[this.inputData.propertyArrayName][this.inputData.index];

      if (!additionalArrayObject) {
        return false;
      }

      defaultValuesData = Object.assign({}, additionalArrayObject.defaultProperties);
    } else {
      defaultValuesData = Object.assign({}, this.productData.defaultProperties);
    }

    if (defaultValuesData && defaultValuesData.hasOwnProperty(this.inputData.propertyName)) {
      if (this.inputData.propertyName === 'vehicleBonus' && defaultValuesData['vehicleBonusYears']) {
        defaultValuesData[this.inputData.propertyName] = `${defaultValuesData[this.inputData.propertyName]},${defaultValuesData['vehicleBonusYears']}`;
      }

      return defaultValuesData[this.inputData.propertyName] === this.value;
    }

    return false;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  afterDatePickerOpenHandler(): void {}

  chosenDateHandler(normalizedYear, id) {
    const dateToSet = moment(normalizedYear).format('DD-MM-YYYY');

    if (this.inputData.propertyConfig.settings.dateView === 'month') {
      this.updateValue(dateToSet);
      this.setDatepickerValue(dateToSet, id);
    }
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: any, id) {
    const dateToSet = moment(normalizedYear).format('YYYY');

    if (
      this.inputData.propertyConfig.settings.dateView === 'multi-years' &&
      +dateToSet <= this.maxDate.getFullYear()
    ) {
      this.updateValue(dateToSet, this.inputData.propertyConfig);
      this.setDatepickerValue(dateToSet, id);
      datepicker.close();
    }
  }

  writeValue(outsideValue: any) {
    const isEmpty = value => value === null || value === undefined || value === '';

    if (this.inputData && isEmpty(outsideValue) && !isEmpty(this.value)) {
      this.value = null;
      return;
    }

    if (
      (this.inputData && outsideValue) ||
      (this.inputData && outsideValue === false) ||
      (this.inputData && outsideValue === 0)
    ) {
      if (outsideValue === 'false') {
        outsideValue = false;
      }
      switch (this.inputData.propertyConfig.inputType) {
        case this.inputTypes.RANGE_BETWEEN: {
          this.minRangeValue = outsideValue[0];
          this.maxRangeValue = outsideValue[1];
          break;
        }
        case this.inputTypes.MULTIPLE_STRING: {
          this.multipleString = outsideValue.map(data => {
            return { value: data };
          });
          break;
        }
        case this.inputTypes.DATE: {
          this.value = outsideValue;
          this.setDatepickerValue(outsideValue, this.dateInputIdLabel + this.inputId);
          break;
        }
        case this.inputTypes.SELECT_DATA_LIST: {
          if (outsideValue === false) {
            outsideValue = 'false';
          }
          if (outsideValue === true) {
            outsideValue = 'true';
          }

          if (outsideValue === CLEAR_SELECT_INPUT_LABEL) {
            outsideValue = '';
          }

          this.value = outsideValue;
          break;
        }
        default: {
          this.value = outsideValue;
          break;
        }
      }
    }
  }

  updateValue(insideValue: any, propertyConfig: any = {}) {
    const previousValue = this.value;

    if (this.isDefaultValue()) {
      if (this.inputData.propertyArrayName) {
        delete this.productData.properties[this.inputData.propertyArrayName]
          [this.inputData.index].defaultProperties[this.inputData.propertyName];
      } else {
        delete this.productData.defaultProperties[this.inputData.propertyName];
      }
    }

    if (this.inputData && !this.inputData.propertyArrayName && previousValue !== insideValue) {
      this.propertiesFormService.markUserModifiedProperty(this.productData, this.inputData.propertyName);
    }

    this.value = insideValue;
    this.onChange(insideValue);
    this.onTouched();

    this.handleAdditionalUpdateForm(insideValue, propertyConfig);
  }

  selectedDataChange() {
    const value = this.selectedData;

    this.updateValue(value);
  }

  updateRange() {
    const value = [this.minRangeValue, this.maxRangeValue];

    this.updateValue(value);
  }

  updateMultipleValue() {
    const value = this.multipleString.map(res => {
      return res.value;
    });

    this.updateValue(value);
  }

  addMultipleValue() {
    this.multipleString.push({value: ''});
    this.updateMultipleValue();
  }

  isValueExistInOptions(value: any): any {
    return this.inputData.propertyConfig.settings.list.find(x => x.value === value);
  }

  handleSelectClass(): void {
    if (this.inputData.propertyConfig.isHugeSelectContainer) {
      setTimeout(() => {
        const el: any = document.querySelector('.select-data-list-option').closest('.options-list-container');

        el.classList.add('huge-width-container');
      });
    }
  }

  handleInputName(inputTypeName: string): string {
    let name = `${inputTypeName}_${this.inputData.propertyArrayName}_${this.inputData.propertyConfig.key}`;

    if (this.inputData.propertyConfig.index !== undefined) {
      name += `_${this.inputId}`;
    }

    return name;
  }

  private setDatepickerValue(value: any, id): void {
    setTimeout(() => {
      (<HTMLInputElement>document.getElementById(id)).value = value;
    });
  }

  private handleAdditionalUpdateForm(insideValue: any, propertyConfig: any = this.inputData.propertyConfig): void {
    this.dynamicInputService.handleAdditionalUpdateFormConfig(
      insideValue,
      propertyConfig,
      this.inputData,
      additionalUpdateValueData => this.updateFormOnSelectValue.emit(additionalUpdateValueData),
      ofvBrandIdSelected => this.ofvBrandIdSelected.emit(),
      ofvModelIdSelected => this.ofvModelIdSelected.emit(),
      ofvModelregYearSelected => this.ofvModelregYearSelected.emit(),
      ofvModelYearSelected => this.ofvModelYearSelected.emit(),
    );
  }
}
